module.exports = __webpack_public_path__ + "static/media/18ECA47.963bd1b5.jpg";